import React from "react";
import Heading from "../LandingPage/Heading";
import HowItWorks from "./HowItWorks";

const CheckIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 55.5C43.1882 55.5 55.5 43.1882 55.5 28C55.5 12.8118 43.1882 0.5 28 0.5C12.8118 0.5 0.5 12.8118 0.5 28C0.5 43.1882 12.8118 55.5 28 55.5ZM37.724 18.276C38.2404 17.7604 38.9404 17.471 39.6702 17.4715C40.3999 17.472 41.0996 17.7624 41.6152 18.2788C42.1309 18.7951 42.4203 19.4952 42.4198 20.2249C42.4193 20.9547 42.1289 21.6544 41.6125 22.17L26.0667 37.7158L26.0557 37.7267C25.801 37.983 25.498 38.1864 25.1643 38.3251C24.8307 38.4639 24.4729 38.5353 24.1115 38.5353C23.7501 38.5353 23.3923 38.4639 23.0587 38.3251C22.725 38.1864 22.422 37.983 22.1672 37.7267L22.1562 37.7158L14.3875 29.947C14.1248 29.6933 13.9153 29.3899 13.7712 29.0544C13.6271 28.7189 13.5512 28.358 13.5481 27.9929C13.5449 27.6277 13.6145 27.2656 13.7527 26.9276C13.891 26.5897 14.0952 26.2826 14.3534 26.0244C14.6116 25.7662 14.9187 25.562 15.2566 25.4237C15.5946 25.2855 15.9567 25.2159 16.3219 25.2191C16.687 25.2222 17.0479 25.2981 17.3834 25.4422C17.7189 25.5863 18.0223 25.7958 18.276 26.0585L24.1115 31.8913L37.724 18.2788V18.276Z"
        fill="#89A8B0"
      />
    </svg>
  );
};

const features = [
  {
    title: "AI-Driven Decision Making",
    description:
      "Trades only in optimal conditions, filtering out unnecessary risks.",
    icon: (
      <svg
        width="55"
        height="49"
        viewBox="0 0 55 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M21.9219 4.58057C11.8378 5.05602 3.8125 13.0344 3.8125 22.8055C3.8125 27.647 5.78229 32.0462 8.99538 35.3108C9.70281 36.0297 10.1751 37.0118 9.98452 38.0225C9.66993 39.6752 8.95697 41.2166 7.91305 42.5014C10.6597 43.0127 13.5156 42.5523 15.9648 41.249C16.8306 40.7885 17.2635 40.558 17.569 40.5113C17.8745 40.4646 18.3121 40.5469 19.1872 40.7112C20.403 40.9398 21.6373 41.0542 22.875 41.0527"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M28.6224 5.31755C30.667 4.09814 32.4516 4.58955 33.5239 5.37231C33.9635 5.69327 34.1833 5.85374 34.3125 5.85374C34.4418 5.85374 34.6615 5.69327 35.1011 5.37231C36.1734 4.58955 37.958 4.09814 40.0027 5.31755C42.6863 6.9179 43.2934 12.1975 37.1036 16.6517C35.9246 17.5001 35.3352 17.9243 34.3125 17.9243C33.2898 17.9243 32.7004 17.5001 31.5214 16.6517C25.3316 12.1975 25.9387 6.9179 28.6224 5.31755Z"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
        />{" "}
        <g clip-path="url(#clip0_4127_14691)">
          {" "}
          <path
            d="M27.25 33.615C27.25 40.0539 32.8472 45.2744 39.75 45.2744C40.5616 45.2755 41.371 45.2022 42.1682 45.0564C42.7421 44.9512 43.029 44.8987 43.2293 44.9285C43.4297 44.9584 43.7135 45.1055 44.2813 45.3999C45.8873 46.2327 47.7601 46.5268 49.5611 46.2002C48.8766 45.3792 48.4091 44.3942 48.2028 43.3383C48.0778 42.6924 48.3875 42.0649 48.8514 41.6056C50.9583 39.5196 52.25 36.7087 52.25 33.615C52.25 27.1762 46.6528 21.9556 39.75 21.9556C32.8472 21.9556 27.25 27.1762 27.25 33.615Z"
            stroke="#89A8B0"
            stroke-width="4"
            stroke-linejoin="round"
          />{" "}
        </g>{" "}
        <defs>
          {" "}
          <clipPath id="clip0_4127_14691">
            {" "}
            <rect
              width="30"
              height="29.25"
              fill="white"
              transform="matrix(-1 0 0 1 54.75 19.5181)"
            />{" "}
          </clipPath>{" "}
        </defs>{" "}
      </svg>
    ),
  },
  {
    title: "Real-Time Risk Management",
    description: "Adjusts to market volatility to protect your capital.",
    icon: (
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M19.3333 16.1967V13.5946C19.3333 10.6647 20.5562 8.13921 22.358 6.01021C23.0588 5.18211 23.4092 4.76807 24 4.76807C24.5908 4.76807 24.9412 5.18211 25.642 6.01021C27.4438 8.13921 28.6666 10.6647 28.6666 13.5946V16.1967C28.6666 18.3395 28.6666 18.9488 29.9614 19.8861C30.997 20.5519 32 21.1967 32 22.4877C32 24.0539 31.3334 24.7681 29.8716 24.7681H18.1283C16.6667 24.7681 16 24.0539 16 22.4877C16 21.1967 17.0029 20.5519 18.0387 19.8861C19.3333 18.9488 19.3333 18.3395 19.3333 16.1967Z"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M39 44.7681C41.7614 44.7681 44 42.3803 44 39.4347C44 36.4893 41.7614 34.1015 39 34.1015C39 31.1559 36.7614 28.7681 34 28.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M9 44.7681C6.23858 44.7681 4 42.3803 4 39.4347C4 36.4893 6.23858 34.1015 9 34.1015C9 31.1559 11.2386 28.7681 14 28.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M20 30.7681V40.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
        />{" "}
        <path
          d="M28 30.7681V34.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
        />{" "}
      </svg>
    ),
  },
  {
    title: "Flexible Risk Levels",
    description:
      "Choose from Conservative, Balanced, Moderate, and Aggressive strategies.",
    icon: (
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M17.4609 43.7661C20.0452 39.3201 25.9638 38.7959 29.3346 42.1933C30.0882 42.9529 30.465 43.3329 30.7992 43.3783C31.1334 43.4237 33.2304 42.2211 33.9748 41.7943C34.7336 41.3593 36.8374 40.1525 36.9696 39.8369C37.1018 39.5211 36.9634 38.9829 36.6866 37.9065C35.6798 33.9923 38.1212 29.8729 42.022 28.8105C43.0658 28.5261 43.5876 28.3838 43.7938 28.112C44 27.8402 44 25.4498 44 24.5752C44 23.7008 44 21.3102 43.7938 21.0384C43.5876 20.7666 43.0658 20.6244 42.022 20.3402C38.1206 19.2777 35.6772 15.1584 36.6836 11.244C36.9602 10.1674 37.0986 9.62911 36.9664 9.31347C36.8342 8.99785 34.7304 7.79123 33.9718 7.35617C33.2272 6.92925 31.1302 5.72669 30.7962 5.77213C30.462 5.81761 30.0852 6.19739 29.3314 6.95699C26.4128 9.89783 21.584 9.89795 18.6655 6.95717C17.9117 6.19759 17.5348 5.81779 17.2007 5.77235C16.8666 5.72689 14.7697 6.92947 14.0252 7.35641C13.2665 7.79149 11.1625 8.99807 11.0303 9.31375C10.8981 9.62943 11.0366 10.1676 11.3134 11.2441C12.3202 15.1584 9.8788 19.2776 5.97804 20.3401C4.93422 20.6244 4.4123 20.7666 4.20616 21.0386C4 21.3102 4 23.7008 4 24.5752C4 25.4498 4 27.8403 4.20616 28.1123C4.41234 28.3841 4.934 28.5261 5.97732 28.8103C5.98956 28.8137 6.00178 28.8171 6.014 28.8203"
          stroke="#89A8B0"
          stroke-width="3"
          stroke-linecap="round"
        />{" "}
        <path
          d="M4.97782 37.1337C7.13782 34.9747 14.4818 27.7057 15.2018 26.8659C15.963 25.9783 15.3458 24.7789 15.713 21.0603C15.8907 19.2611 16.2779 17.9131 17.3858 16.9101C18.7058 15.6626 19.7858 15.6626 23.5058 15.5786C26.7458 15.6626 27.1298 15.3027 27.4658 16.1424C27.7058 16.7421 26.9858 17.102 26.1218 18.0616C24.2018 19.9808 23.0738 20.9405 22.9658 21.5403C22.1858 24.1791 25.2578 25.7385 26.9378 24.0591C27.5732 23.4241 30.5138 20.4606 30.8018 20.2207C31.0178 20.0288 31.5348 20.0381 31.7858 20.3406C32.0018 20.5528 32.0258 20.5805 32.0018 21.5401C31.9796 22.4285 31.9896 23.7037 31.9922 25.0187C31.9958 26.7227 31.9058 28.6173 31.1858 29.5769C29.7458 31.7359 27.3458 31.8559 25.1858 31.9519C23.1458 32.0719 21.4658 31.8559 20.9378 32.2397C20.5058 32.4557 18.2258 34.8547 15.4658 37.6135L10.5458 42.5315C6.46582 45.7703 1.97782 40.7323 4.97782 37.1337Z"
          stroke="#89A8B0"
          stroke-width="3"
          stroke-linecap="round"
        />{" "}
      </svg>
    ),
  },
  {
    title: "Fully Automated Execution",
    description: "No manual input required; the EA operates 24/5.",
    icon: (
      <svg
        width="55"
        height="49"
        viewBox="0 0 55 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M21.9219 4.58057C11.8378 5.05602 3.8125 13.0344 3.8125 22.8055C3.8125 27.647 5.78229 32.0462 8.99538 35.3108C9.70281 36.0297 10.1751 37.0118 9.98452 38.0225C9.66993 39.6752 8.95697 41.2166 7.91305 42.5014C10.6597 43.0127 13.5156 42.5523 15.9648 41.249C16.8306 40.7885 17.2635 40.558 17.569 40.5113C17.8745 40.4646 18.3121 40.5469 19.1872 40.7112C20.403 40.9398 21.6373 41.0542 22.875 41.0527"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M28.6224 5.31755C30.667 4.09814 32.4516 4.58955 33.5239 5.37231C33.9635 5.69327 34.1833 5.85374 34.3125 5.85374C34.4418 5.85374 34.6615 5.69327 35.1011 5.37231C36.1734 4.58955 37.958 4.09814 40.0027 5.31755C42.6863 6.9179 43.2934 12.1975 37.1036 16.6517C35.9246 17.5001 35.3352 17.9243 34.3125 17.9243C33.2898 17.9243 32.7004 17.5001 31.5214 16.6517C25.3316 12.1975 25.9387 6.9179 28.6224 5.31755Z"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
        />{" "}
        <g clip-path="url(#clip0_4127_14691)">
          {" "}
          <path
            d="M27.25 33.615C27.25 40.0539 32.8472 45.2744 39.75 45.2744C40.5616 45.2755 41.371 45.2022 42.1682 45.0564C42.7421 44.9512 43.029 44.8987 43.2293 44.9285C43.4297 44.9584 43.7135 45.1055 44.2813 45.3999C45.8873 46.2327 47.7601 46.5268 49.5611 46.2002C48.8766 45.3792 48.4091 44.3942 48.2028 43.3383C48.0778 42.6924 48.3875 42.0649 48.8514 41.6056C50.9583 39.5196 52.25 36.7087 52.25 33.615C52.25 27.1762 46.6528 21.9556 39.75 21.9556C32.8472 21.9556 27.25 27.1762 27.25 33.615Z"
            stroke="#89A8B0"
            stroke-width="4"
            stroke-linejoin="round"
          />{" "}
        </g>{" "}
        <defs>
          {" "}
          <clipPath id="clip0_4127_14691">
            {" "}
            <rect
              width="30"
              height="29.25"
              fill="white"
              transform="matrix(-1 0 0 1 54.75 19.5181)"
            />{" "}
          </clipPath>{" "}
        </defs>{" "}
      </svg>
    ),
  },
  {
    title: "Integrated VPS Hosting",
    description:
      "PROFITPULSE comes pre-installed on a dedicated VPS, ensuring stability & security.",
    icon: (
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M19.3333 16.1967V13.5946C19.3333 10.6647 20.5562 8.13921 22.358 6.01021C23.0588 5.18211 23.4092 4.76807 24 4.76807C24.5908 4.76807 24.9412 5.18211 25.642 6.01021C27.4438 8.13921 28.6666 10.6647 28.6666 13.5946V16.1967C28.6666 18.3395 28.6666 18.9488 29.9614 19.8861C30.997 20.5519 32 21.1967 32 22.4877C32 24.0539 31.3334 24.7681 29.8716 24.7681H18.1283C16.6667 24.7681 16 24.0539 16 22.4877C16 21.1967 17.0029 20.5519 18.0387 19.8861C19.3333 18.9488 19.3333 18.3395 19.3333 16.1967Z"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M39 44.7681C41.7614 44.7681 44 42.3803 44 39.4347C44 36.4893 41.7614 34.1015 39 34.1015C39 31.1559 36.7614 28.7681 34 28.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M9 44.7681C6.23858 44.7681 4 42.3803 4 39.4347C4 36.4893 6.23858 34.1015 9 34.1015C9 31.1559 11.2386 28.7681 14 28.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />{" "}
        <path
          d="M20 30.7681V40.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
        />{" "}
        <path
          d="M28 30.7681V34.7681"
          stroke="#89A8B0"
          stroke-width="4"
          stroke-linecap="round"
        />{" "}
      </svg>
    ),
  },
  {
    title: "Comprehensive Dashboard",
    description: "Track live market sentiment, and risk levels in real time.",
    icon: (
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M17.4609 43.7661C20.0452 39.3201 25.9638 38.7959 29.3346 42.1933C30.0882 42.9529 30.465 43.3329 30.7992 43.3783C31.1334 43.4237 33.2304 42.2211 33.9748 41.7943C34.7336 41.3593 36.8374 40.1525 36.9696 39.8369C37.1018 39.5211 36.9634 38.9829 36.6866 37.9065C35.6798 33.9923 38.1212 29.8729 42.022 28.8105C43.0658 28.5261 43.5876 28.3838 43.7938 28.112C44 27.8402 44 25.4498 44 24.5752C44 23.7008 44 21.3102 43.7938 21.0384C43.5876 20.7666 43.0658 20.6244 42.022 20.3402C38.1206 19.2777 35.6772 15.1584 36.6836 11.244C36.9602 10.1674 37.0986 9.62911 36.9664 9.31347C36.8342 8.99785 34.7304 7.79123 33.9718 7.35617C33.2272 6.92925 31.1302 5.72669 30.7962 5.77213C30.462 5.81761 30.0852 6.19739 29.3314 6.95699C26.4128 9.89783 21.584 9.89795 18.6655 6.95717C17.9117 6.19759 17.5348 5.81779 17.2007 5.77235C16.8666 5.72689 14.7697 6.92947 14.0252 7.35641C13.2665 7.79149 11.1625 8.99807 11.0303 9.31375C10.8981 9.62943 11.0366 10.1676 11.3134 11.2441C12.3202 15.1584 9.8788 19.2776 5.97804 20.3401C4.93422 20.6244 4.4123 20.7666 4.20616 21.0386C4 21.3102 4 23.7008 4 24.5752C4 25.4498 4 27.8403 4.20616 28.1123C4.41234 28.3841 4.934 28.5261 5.97732 28.8103C5.98956 28.8137 6.00178 28.8171 6.014 28.8203"
          stroke="#89A8B0"
          stroke-width="3"
          stroke-linecap="round"
        />{" "}
        <path
          d="M4.97782 37.1337C7.13782 34.9747 14.4818 27.7057 15.2018 26.8659C15.963 25.9783 15.3458 24.7789 15.713 21.0603C15.8907 19.2611 16.2779 17.9131 17.3858 16.9101C18.7058 15.6626 19.7858 15.6626 23.5058 15.5786C26.7458 15.6626 27.1298 15.3027 27.4658 16.1424C27.7058 16.7421 26.9858 17.102 26.1218 18.0616C24.2018 19.9808 23.0738 20.9405 22.9658 21.5403C22.1858 24.1791 25.2578 25.7385 26.9378 24.0591C27.5732 23.4241 30.5138 20.4606 30.8018 20.2207C31.0178 20.0288 31.5348 20.0381 31.7858 20.3406C32.0018 20.5528 32.0258 20.5805 32.0018 21.5401C31.9796 22.4285 31.9896 23.7037 31.9922 25.0187C31.9958 26.7227 31.9058 28.6173 31.1858 29.5769C29.7458 31.7359 27.3458 31.8559 25.1858 31.9519C23.1458 32.0719 21.4658 31.8559 20.9378 32.2397C20.5058 32.4557 18.2258 34.8547 15.4658 37.6135L10.5458 42.5315C6.46582 45.7703 1.97782 40.7323 4.97782 37.1337Z"
          stroke="#89A8B0"
          stroke-width="3"
          stroke-linecap="round"
        />{" "}
      </svg>
    ),
  },
];

export default function FeatureSection() {
  return (
    <div className="feature-bg text-white pb-[260px]" id="feature-section">
      <div className="container mx-auto px-4">
        <section className="flex flex-col items-center justify-center lg:space-y-16 space-y-10 px-6 py-10 lg:py-16 text-white">
          <Heading title={"Features"} dashTitle={"Features"} />

          <div className="grid grid-cols-2 md:grid-cols-3  text-white">
            {features.map((feature, index) => (
              <div key={index} className="border border-[#464155] p-6 relative">
                <div className="text-4xl mb-4 p-4 bg-[#89A8B0] bg-opacity-[0.06] inline-flex rounded-md">
                  {feature.icon}
                </div>
                <h3 className="text-md md:text-2xl font-semibold">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm md:text-md mt-2 mb-16">
                  {feature.description}
                </p>
                <div className="absolute bottom-6 right-6">
                  <CheckIcon />
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6 flex justify-center md:justify-start">
            <a
              href="/#contact-section"
              className="rounded-full bg-transparent hover:bg-[#87A3A8] border-white hover:border-black border px-6 py-3 text-sm font-medium text-white hover:text-black shadow-md transition"
            >
              CONTACT US
            </a>
          </div>
        </section>
      </div>

      <HowItWorks />
    </div>
  );
}
